/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { TickerBidderDto } from '../models/ticker-bidder-dto';

@Injectable({
  providedIn: 'root',
})
export class GeneratedTickerBidderService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getTickerBidders
   */
  static readonly GetTickerBiddersPath = '/api/ticker/bidders/{ids}';

  /**
   * Gets one or more bidders by their ids.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTickerBidders()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTickerBidders$Response(params: {
    ids: string;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<TickerBidderDto>>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedTickerBidderService.GetTickerBiddersPath, 'get');
    if (params) {
      rb.path('ids', params.ids, {});
      rb.header('X-API-Version', params['X-API-Version'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TickerBidderDto>>;
      })
    );
  }

  /**
   * Gets one or more bidders by their ids.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTickerBidders$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTickerBidders(params: {
    ids: string;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<Array<TickerBidderDto>> {

    return this.getTickerBidders$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<TickerBidderDto>>) => r.body as Array<TickerBidderDto>)
    );
  }

}
